
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/addPanelInfra/newAddPanel/components/logo/logoSection.scss.css.virtualfile';
        module.exports = {"illustration":"_illustration_brstp_1"};